// @mui
import {
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  Table,
  TableHead,
  Chip,
} from "@mui/material";

const getLevelStyle = (amount) => {
  if (amount >= 1 && amount <= 8) {
    return {
      backgroundColor: "#4caf50",
      color: "white",
      label: "Base",
    };
  } else if (amount >= 9 && amount <= 15) {
    return {
      backgroundColor: "#ffd700",
      color: "black",
      label: "Gold",
    };
  } else if (amount >= 20 && amount <= 25) {
    return {
      backgroundColor: "#9c27b0",
      color: "white",
      label: "Purple",
    };
  } else {
    return {
      backgroundColor: "#757575",
      color: "white",
      label: "Unknown",
    };
  }
};

// Function to format pack type
const getPackTypeLabel = (packType) => {
  switch (packType) {
    case 0:
      return "Daily";
    case 1:
      return "Store Pack 5";
    case 2:
      return "Store Pack 12";
    default:
      return "";
  }
};

const formatDateToET = (utcDate) => {
  if (!utcDate) return "";
  const date = new Date(utcDate);
  return date.toLocaleString("en-US", {
    timeZone: "America/New_York",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
};

export default function VersusContractsTable(props) {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Pack ID</TableCell>
            <TableCell>Pack Type</TableCell>
            <TableCell>Level</TableCell>
            <TableCell>Active</TableCell>
            <TableCell>Created At</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props?.rows?.map((row, index) => (
            <TableRow
              key={index}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
              }}
            >
              <TableCell component="th" scope="row">
                {row.versusUserGameContractId}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.versusPackId}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.versusPackId && (
                  <Chip
                    label={getPackTypeLabel(row.packType)}
                    color="primary"
                    size="small"
                    variant="outlined"
                  />
                )}
              </TableCell>
              <TableCell component="th" scope="row">
                {(() => {
                  const levelStyle = getLevelStyle(row.amount);
                  return (
                    <Chip
                      label={row.amount}
                      sx={{
                        backgroundColor: levelStyle.backgroundColor,
                        color: levelStyle.color,
                        fontWeight: "bold",
                        minWidth: "60px",
                        minHeight: "80px",
                        fontSize: "2rem",
                      }}
                    />
                  );
                })()}
              </TableCell>

              <TableCell component="th" scope="row">
                <Chip
                  label={row.isActive ? "Active" : "Used"}
                  color={row.isActive ? "success" : "error"}
                  size="small"
                />
              </TableCell>

              <TableCell component="th" scope="row">
                {formatDateToET(row.createdAt)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
